import { Divider, Paper, Skeleton } from "@mui/material";
import { Theme247 } from "../../../../../styles/Theme247";
import { Box } from "@mui/system";

function TemplateSkeliton() {
  return (
    <div>
      <section style={{ marginBottom: "35%" }}>
        <Paper elevation={Theme247.elevationLow}>
          <div className="MO_Skeliton_Wrapper">
            {" "}
            <Box>
              <div className="MO_Skeliton" style={{ alignItems: "start" }}>
                <div style={{ width: "90%", display: "flex" }}>
                  <div style={{ width: "45%", marginTop: "70px" }}>
                    <Skeleton animation="wave" height={60} />
                    <Skeleton animation="wave" height={60} />
                    <Skeleton animation="wave" height={60} />
                  </div>
                  <div style={{ width: "45%", marginTop: "70px" }}>
                    <Skeleton animation="wave" height={60} />
                    <Skeleton animation="wave" height={60} />
                    <Skeleton animation="wave" height={60} />
                  </div>
                </div>
                <div style={{ width: "10%" }}>
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    id="MO_Skeliton_Image"
                    style={{ width: "100%", height: "16%" }}
                  />
                </div>
              </div>
            </Box>
            <Divider />

<br></br>
            <Skeleton animation="wave" height={20} width={100} />

            <div className="MO_Skeliton" style={{ alignItems: "start" }}>
              <div style={{ width: "90%", display: "flex" }}>
                <div style={{ width: "45%", marginTop: "10px" }}>
                  <Skeleton animation="wave" height={60} />
                  <Skeleton animation="wave" height={60} />
                  <Skeleton animation="wave" height={60} />
                </div>
                <div style={{ width: "45%", marginTop: "10px" }}>
                  <Skeleton animation="wave" height={60} />
                  <Skeleton animation="wave" height={60} />
                  <Skeleton animation="wave" height={60} />
                </div>
              </div>
              <div style={{ width: "10%" }}></div>
            </div>
          </div>
        </Paper>
      </section>
    </div>
  );
}

export default TemplateSkeliton;
